import React, { PropsWithChildren } from "react";
import { useSessionStorage } from "usehooks-ts";
import {
  OIDCAuthProvider,
  POST_LOGIN_REDIRECT_KEY,
  SIGN_IN_CALLBACK_URL,
  OIDC_BROADCAST_SIGNIN_USER,
  WebStorageStateStore,
  UserManager,
  getProfileCheckerAuthQueryParams,
  oidcBroadcastChannel,
  oidcTabId,
} from "shared-auth";
import { config } from "../../../../config";

const oidcConfig = {
  authority: config.oidc?.authority,
  client_id: config.oidc?.clientId,
  scope: config.oidc?.scope,
  response_type: "code",
  redirect_uri: `${config.frontEndUrl}/${SIGN_IN_CALLBACK_URL}`,
  post_logout_redirect_uri: config.portalApiLogoutUrl,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  loadUserInfo: true,
  automaticSilentRenew: false,
  // need this to identify congnito users for the profile app
  extraQueryParams: getProfileCheckerAuthQueryParams(),
};

export const userManager = new UserManager(oidcConfig);

const AuthProvider = ({ children }: PropsWithChildren) => {
  const [postLoginRedirect] = useSessionStorage<string>(
    POST_LOGIN_REDIRECT_KEY,
    config.frontEndUrl
  );

  return (
    <OIDCAuthProvider
      userManager={userManager}
      onSigninCallback={() => {
        oidcBroadcastChannel.postMessage({
          type: OIDC_BROADCAST_SIGNIN_USER,
          sender: oidcTabId,
        });

        window.location.replace(postLoginRedirect);
      }}
    >
      {children}
    </OIDCAuthProvider>
  );
};

export default AuthProvider;
